document.addEventListener("DOMContentLoaded", function() {
    function SetMarket() {
        localStorage.setItem('cont', 'true');
    }

    async function getCurrentLocationData() {
        try {
          const response = await fetch('/browsing_context_suggestions.json?source=geolocation_recommendation&country[enabled]=true&language[enabled]=true');
          if (response.ok) {
            const data = await response.json();
            let Detected = data.detected_values
            var country = localStorage.getItem('cont');
            if (country != null) {
              document.getElementById('languageCountryPopup').classList.add('hidden');
              document.getElementById('shopify-section-language-popup').style.display = 'none';
            } 
            var visiting_title = document.getElementById('languageCountryPopup').dataset.visiting_title;
            var st = visiting_title.replace('country_name', data.detected_values.country_name);
            document.getElementById('VisitingMsg').innerHTML = st;
            var downcase_country = data.detected_values.country_name;
            downcase_country = downcase_country.toLowerCase(); 
            
            var languageOptions = document.querySelectorAll('select[name="langauge_code"] option');
            languageOptions.forEach(function(option) {
                option.disabled = true; 
                option.removeAttribute("selected");
            });

            var selectedValue = document.querySelector('select[name="country_code_select"]')?.value;
            var selectedLanguage = document.querySelector('input[name="locale_code"]')?.value.toLowerCase();
            
            document.querySelectorAll('select[name="langauge_code"] option[data-country_name="' + selectedValue + '"]').forEach(function(option) {
                option.removeAttribute("disabled");
            });
            var selectElement = document.querySelector('select[name="langauge_code"]');
            var options = selectElement.querySelectorAll('option');
            for (var i = 0; i < options.length; i++) {
                var option = options[i];
                var countryName = option.getAttribute('data-country_name');
                var countryCodeFlagLang = option.getAttribute('data-country_code_flag_lang');

                if (countryName === selectedValue && countryCodeFlagLang === selectedLanguage) {
                    option.selected = true;  
                    option.setAttribute('selected', 'selected');
                    option.defaultSelected = true;  
                }
            }

          } else {
            throw new Error('Request failed with status ' + response.status);
          }
        } catch (error) { 
          console.log('Error:', error.message);
        }
      }

    getCurrentLocationData();

    document.querySelector('select[name="country_code_select"]').addEventListener('change', function() {
        var selectedValue = this.value;
        var spanElement = document.getElementById('selected-country');
        spanElement.classList.remove();

        var lowercase_value = document.querySelector('select[name="country_code_select"] option[value="' + selectedValue + '"]').getAttribute("data-country_code_flag").toLowerCase();
        spanElement.classList.add('absolute', 'top-[33px]', 'right-[42%]', 'fi', 'fis', 'rounded-[14px]', 'px-[10px]', 'h-[18px]', 'border', 'border-gray-300', 'fi', 'fi-' + lowercase_value); 
        var languageOptions = document.querySelectorAll('select[name="langauge_code"] option');
        languageOptions.forEach(function(option) {
            option.disabled = true; 
            option.removeAttribute("selected");
        });

        var selectedValue = document.querySelector('select[name="country_code_select"]').value;
        var selectedLanguage = document.querySelector('select[name="langauge_code"]')?.value.toLowerCase();

        document.querySelectorAll('select[name="langauge_code"] option[data-country_name="' + selectedValue + '"]').forEach(function(option, index) {
            option.removeAttribute("disabled");
            if(index == 0) {
                option.setAttribute("selected", "selected");
            }
        });

        var selectElement = document.querySelector('select[name="langauge_code"]');
        var options = selectElement.querySelectorAll('option'); 
        for (var i = 0; i < options.length; i++) {
            var option = options[i];
            var countryName = option.getAttribute('data-country_name');
            var countryCodeFlagLang = option.getAttribute('data-country_code_flag_lang');

            if (countryName === selectedValue && countryCodeFlagLang === selectedLanguage) {
                option.selected = true;  
                option.setAttribute('selected', 'selected');
                option.defaultSelected = true;  
            }
        }
   
        var input_hidden_val = document.querySelector('select[name="country_code_select"] option[value="' + selectedValue + '"]').getAttribute("data-country_code_flag").toUpperCase();
        if (input_hidden_val == "EU") {
            input_hidden_val = document.querySelector('select[name="country_code_select"] option[value="' + selectedValue + '"]').getAttribute("data-backup-country_code").toUpperCase();
        }
        document.querySelector('input[name="country_code"]').value = input_hidden_val;
        var selectedOption = document.querySelector('select[name="langauge_code"]').value;
        var all_options = document.querySelectorAll('select[name="langauge_code"] option');
        all_options.forEach(function(option) {
            if(option.getAttribute('value') == selectedOption) {
                var lan_selected_val = option.getAttribute('data-country_code_flag_lang').toUpperCase();
                document.querySelector('input[name="locale_code"]').value = lan_selected_val;
            }
        });       
      });


    document.querySelector('select[name="langauge_code"]').addEventListener('change', function() {
        var selectedValue = this.value;
        var input_lang_hidden_val = document.querySelector('select[name="langauge_code"] option[value="' + selectedValue + '"]').getAttribute("data-country_code_flag_lang").toUpperCase();
        var selected_lan_val = document.querySelector('select[name="langauge_code"] option[value="' + selectedValue + '"]').getAttribute("data-country_code_flag_lang");
        document.querySelector('input[name="locale_code"]').value = input_lang_hidden_val;
        var options = document.querySelectorAll('[name="langauge_code"] option');
        options.forEach(function(option) {
            option.removeAttribute("selected");
        });
        document.querySelector('[name="langauge_code"] option[value="' + selectedValue + '"][data-country_code_flag_lang="' + selected_lan_val + '"]').setAttribute('selected', 'selected');
    });

    
document.querySelector('.popup_submit').addEventListener('click', function(e) {
        e.preventDefault();
        var selectedLanguage = document.querySelector('select[name="langauge_code"] option[selected="selected"]').value;
        var selectedCountry = document.querySelector('select[name="country_code_select"]').value;
        var key = selectedLanguage + '_' + selectedCountry;
        if (!all_country[key]) {
            document.getElementById("CountryLanguage").submit();
        } else {
            window.location = all_country[key];
        }
});

document.querySelector('.hide_popup').addEventListener('click', function(e) {
    var popup = document.getElementById("languageCountryPopup");
    var popupParent = document.getElementById("shopify-section-language-popup");
    popupParent.style.display = "none";
    popup.classList.toggle("hidden");
    localStorage.setItem('cont', 'true');
});

});    